var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBeta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 15,
    viewBox: "0 0 32 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_190",
    "data-name": "Group 190",
    transform: "translate(-2260 -1391.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_189",
    "data-name": "Group 189"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_188",
    "data-name": "Group 188"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_187",
    "data-name": "Group 187"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_186",
    "data-name": "Group 186"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_185",
    "data-name": "Group 185"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_184",
    "data-name": "Group 184"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M2270.171,1400.582a1.873,1.873,0,0,1-.61,1.43,2.1,2.1,0,0,1-1.489.568h-3v-7h2.778a2.028,2.028,0,0,1,1.449.561,1.8,1.8,0,0,1,.6,1.378,1.683,1.683,0,0,1-.71,1.43A1.776,1.776,0,0,1,2270.171,1400.582Zm-3.948-3.918v1.838h1.629a.919.919,0,0,0,0-1.838Zm1.849,4.838a.98.98,0,0,0,0-1.959h-1.849v1.959Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M2272.7,1401.48h3.1v1.1h-4.247v-7h4.2v1.1H2272.7v1.818h2.8v1.09h-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M2281.74,1395.584v1.1h-1.969v5.9h-1.149v-5.9h-1.979v-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M2286.708,1402.58l-.49-1.408h-2.978l-.49,1.408h-1.25l2.539-7h1.379l2.529,7Zm-3.088-2.488h2.218l-1.109-3.158Z"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M2288.5,1406.5h-25a3.5,3.5,0,0,1-3.5-3.5v-8a3.5,3.5,0,0,1,3.5-3.5h25a3.5,3.5,0,0,1,3.5,3.5v8A3.5,3.5,0,0,1,2288.5,1406.5Zm-25-14a2.5,2.5,0,0,0-2.5,2.5v8a2.5,2.5,0,0,0,2.5,2.5h25a2.5,2.5,0,0,0,2.5-2.5v-8a2.5,2.5,0,0,0-2.5-2.5Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBeta);
export default __webpack_public_path__ + "static/media/icon-beta.4b08d2f01f950223a38858113f497968.svg";
export { ForwardRef as ReactComponent };